import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { ExclamationTriangle, HouseFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import './home/Home.css';

function PageNotFound() {
    const { t } = useTranslation('messages');

    return (
        <Container
            fluid
            className="home-hero text-white d-flex align-items-center"
            style={{ minHeight: 'calc(100vh - 56px)' }}
        >
            <Container className="text-center py-5 position-relative" style={{ zIndex: 1 }}>
                <ExclamationTriangle size={64} className="mb-3 opacity-75" />
                <h1 className="display-1 fw-bold mb-2">404</h1>
                <p className="lead text-white-50 mb-4">{t('main.page_not_found.body')}</p>
                <Button variant="light" href="/" className="fw-semibold px-4">
                    <HouseFill size={15} className="me-2" />
                    {t('main.navbar.home')}
                </Button>
            </Container>
        </Container>
    );
}

export default PageNotFound;
